import {WorkforcePanel} from './WorkforcePanel';
import {ContractsPanel} from './ContractsPanel';
import {JournalPanel} from './JournalPanel';
import{RanchOperationsPanel}from'./RanchOperationsPanel';
import {GuestMapPanel} from './GuestMapPanel';
import { staffDeployTarget } from '../staff-roster';
import { groupOfficeSections } from '../office-groups';
import { useEffect, useRef, useState } from 'preact/hooks';
import { StandingPanel } from './StandingPanel';
import { AdvisorsPanel } from './AdvisorsPanel';
import { ForecastPanel } from './ForecastPanel';
import { PriceHistoryPanel } from './PriceHistoryPanel';
import { PedigreePanel } from './PedigreePanel';
import { StudbookPanel } from './StudbookPanel';
import { TourismPanel } from './TourismPanel';
import { GuestResearchPanel } from './GuestResearchPanel';
import { BusinessOverviewPanel } from './BusinessOverviewPanel';
import { ResearchPanel } from './ResearchPanel';
import { IdentityPanel } from './IdentityPanel';
import { StoryPanel } from './StoryPanel';
import { StaffCareerPanel } from './StaffCareerPanel';
import { FacilitiesPanel } from './FacilityPanels';
import { BreedingLabPanel } from './BreedingLab';
import { VegetationPanel, RestorationPanel, ZooPanel, InsurancePanel, BuyersPanel, TaxesPanel, ArrivalsPanel, SeasonPanel, CreditPanel, GeneticsPanel, MeatPanel, PartnersPanel, RewildingPanel, SpecialsPanel } from './BusinessPanels';
import { useStore } from '../store';
import { fmtMoney, speciesLabel } from '../bridge';
import type { RegionMissing } from '../bridge';
import { Sheet } from '../components/Sheet';
import {
  IconChevron, IconDoc, IconFinance, IconFlask, IconHandshake,
  IconHat, IconLand, IconTag, IconWarn,
} from '../components/icons';
import portraitRanger from '../assets/portrait-ranger.png';
import portraitVet from '../assets/portrait-veterinarian.png';
import portraitScout from '../assets/portrait-scout.png';

const PORTRAITS: Record<string, string> = {
  ranger: portraitRanger, veterinarian: portraitVet, scout: portraitScout,
};

export const SECTIONS = [
  {id:'workforce',label:'Ranch work board',hint:'Care backlog, veterinary coverage and repair staffing',Icon:IconHat},
  {id:'journal',label:'Field journal',hint:'Recorded wildlife discoveries and ranch history',Icon:IconDoc},
  {id:'guest-map',label:'Guest ranch build',hint:'Paths, entrances and local services',Icon:IconLand},
  { id: 'identity', label: 'Who you are', hint: 'Paths and what you are known for', Icon: IconHat },
  { id: 'story', label: 'Story', hint: 'Campaign progress and celebrated moments', Icon: IconDoc },
  { id: 'staff', label: 'Staff & Rangers', hint: 'Roster, fatigue, deployment', Icon: IconHat },
  { id: 'finance', label: 'Finance', hint: 'Monthly income, expense, net', Icon: IconFinance },
  { id: 'overview', label: 'Business overview', hint: 'Cash flow by stream, partners, outlook', Icon: IconFinance },
  { id: 'reports', label: 'Reports', hint: 'Reserve performance', Icon: IconDoc },
  { id: 'research', label: 'Research', hint: 'Habitat and care studies', Icon: IconFlask },
  { id: 'advisors', label: 'Advisors', hint: 'Vet, ecologist, accountant, ranger', Icon: IconHat },
  { id: 'forecast', label: 'Forecast', hint: 'Modeled spending scenario', Icon: IconFinance },
  { id: 'price-history', label: 'Market prices', hint: 'Recorded species reference-price history', Icon: IconFinance },
  { id: 'contracts', label: 'Contracts', hint: 'Zoo and buyer agreements', Icon: IconHandshake },
  { id: 'dealer', label: 'Dealer', hint: 'Quick-acquire animals', Icon: IconTag },
  { id: 'breedlab', label: 'Breeding lab', hint: 'Pick two animals, inspect, see odds', Icon: IconFlask },
  { id: 'breeding', label: 'Breeding', hint: 'Pregnancies, due dates and pedigrees', Icon: IconFlask },
  { id: 'studbook', label: 'Studbook', hint: 'Herd kinship, founders and recommended pairings', Icon: IconDoc },
  { id: 'vegetation', label: 'Pasture and forage', hint: 'Forage, bare soil, recovery time', Icon: IconLand },
  { id: 'restoration', label: 'Restoration and carbon', hint: 'Restore land, sell credits', Icon: IconLand },
  { id: 'zoo', label: 'Zoo gate', hint: 'Ticket price, visitors, top attractions', Icon: IconTag },
  { id: 'insurance', label: 'Insurance', hint: 'Cover tiers, premiums, payouts', Icon: IconFinance },
  { id: 'buyers', label: 'Ranch buyers', hint: 'Fill other ranches\' wants at a premium', Icon: IconTag },
  { id: 'taxes', label: 'Taxes', hint: 'Next bill, easements', Icon: IconFinance },
  { id: 'arrivals', label: 'Auctions and arrivals', hint: 'Cancel listings, claim crates, challenges', Icon: IconTag },
  { id: 'season', label: 'Season', hint: 'Current season and what is next', Icon: IconDoc },
  { id: 'careers', label: 'Staff careers', hint: 'Train, promote, mentor', Icon: IconHat },
  { id: 'facilities', label: 'Facilities and upkeep', hint: 'Build, upgrade, repair, convert, camp', Icon: IconLand },
  { id: 'credit', label: 'Credit and debt', hint: 'Rating, missed payments, loan rate', Icon: IconFinance },
  { id: 'meat', label: 'Meat and jerky', hint: 'Process, cure, sell by channel', Icon: IconTag },
  { id: 'specials', label: 'Specials', hint: 'Marketing promos per revenue stream', Icon: IconTag },
  { id: 'partners', label: 'Partners', hint: 'Revenue-share deals', Icon: IconHandshake },
  { id: 'genetics', label: 'Genetics exchange', hint: 'Order, send and apply samples', Icon: IconFlask },
  { id: 'rewilding', label: 'Rewilding', hint: 'Send herds overseas for a bonus', Icon: IconLand },
  { id: 'tourism', label: 'Tourism', hint: 'Tours, lodging, events', Icon: IconHandshake },
  { id: 'guest-business', label: 'Guest business', hint: 'Research bonuses: lodging, tours, gate', Icon: IconFlask },
  { id: 'standing', label: 'Standing', hint: 'Reputation, licences, programs, grants', Icon: IconHandshake },
  { id: 'security', label: 'Security', hint: 'Ranger patrols and poaching incidents', Icon: IconHandshake },
  { id: 'lodge', label: 'Lodge', hint: 'Hunting bookings, rates, guest reports', Icon: IconHandshake },
  { id: 'land', label: 'Land', hint: 'Parcels and valuation', Icon: IconLand },
] as const;

/** Staff & Rangers card per refs/mockup-staff-card.png */
function StaffPanel() {
  const { sim, bridge, closePanel } = useStore();
  const [seg, setSeg] = useState<'assigned' | 'available'>('assigned');
  const [deployN, setDeployN] = useState(1);
  const [deployTargetId, setDeployTargetId] = useState<string | null>(null);
  const deployTarget = staffDeployTarget(sim.enclosures, deployTargetId);
  const roster = sim.staff;
  const shown = roster.filter((m) => (seg === 'assigned' ? m.assignedTo !== null : m.assignedTo === null));
  // Ink-style portraits per ref-05; provenance in src/ui/assets/PROVENANCE.md
  const portrait = (p: string) => <img src={PORTRAITS[p]} alt="" style="width:100%;height:100%;object-fit:cover;border-radius:calc(var(--ui-radius) - 4px)" />;
  return (
    <div style="padding:6px 18px 16px">
      <div style="text-align:center">
        <div class="eyebrow eyebrow-rule">Wildlife Reserve - Operations</div>
        <div class="display" style="font-size:25px;margin:8px 0 6px">Staff &amp; Rangers</div>
        <div class="eyebrow eyebrow-rule">Roster - {roster.filter((m) => m.assignedTo !== null).length} active</div>
      </div>
      <div style="margin-top:10px">
        {sim.staffRoles.map((r) => (
          <div class="row" key={r.role} style="padding:6px 12px 6px 6px;border:var(--ui-border);border-radius:var(--ui-radius);background:#F8F2E4;margin-bottom:6px">
            <span class="row-ic" style="border-radius:calc(var(--ui-radius) - 4px);width:76px;height:60px;border:1px solid var(--ui-ink-faint);overflow:hidden">{portrait(r.portrait)}</span>
            <span class="row-main">
              <div class="display" style="font-size:17px">{r.role}</div>
              <div class="row-label" style="white-space:nowrap;font-size:10.5px;letter-spacing:0.05em">{r.duty}</div>
            </span>
            <span class="display" style="font-size:26px;padding-left:12px;border-left:1px solid var(--ui-ink-faint)">{r.count}</span>
          </div>
        ))}
      </div>
      <label style="display:block;margin-top:12px">
        <span class="eyebrow" style="display:block;font-size:11px;margin-bottom:5px">Manual deployment destination</span>
        <select aria-label="Staff deployment destination" value={deployTarget?.id ?? ''} onChange={e => { setDeployTargetId(e.currentTarget.value); }} style="width:100%;min-width:0;padding:10px;border:var(--ui-border);border-radius:var(--ui-radius);background:var(--ui-parchment-soft)">
          <option value="" disabled>Select an enclosure</option>
          {sim.enclosures.map(e => <option key={e.id} value={e.id}>{e.id} - {e.type.replace(/_/g, ' ')} - {e.animalCount} animals</option>)}
        </select>
        <span class="row-label" style="display:block;white-space:normal;font-size:10px;margin-top:4px">Deploy and Deploy team use this enclosure. Recall keeps the worker on your staff.</span>
      </label>
      <div class="seg" style="margin-top:10px">
        <button class={seg === 'assigned' ? 'on' : ''} onClick={() => { setSeg('assigned'); }}>Assigned</button>
        <button class={seg === 'available' ? 'on' : ''} onClick={() => { setSeg('available'); }}>Available</button>
      </div>
      <div style="margin-top:8px">
        {shown.length === 0 && <div class="row-label" style="text-align:center;padding:6px">No {seg} staff</div>}
        {shown.map((m) => (
          <div class="row" key={m.id} style="padding:6px 4px">
            <span class="row-main">
              <div class="row-value" style="font-size:14px;text-transform:capitalize">{m.role} <span class="row-label">{m.id}</span></div>
              <div class="row-label" style="white-space:normal;font-size:10px">fatigue {m.fatigue} - ${fmtMoney(m.wagePerDay)}/day{m.assignedTo ? ` - at ${m.assignedTo}` : ''}{m.manager === true ? ' - manager: demote in Staff careers before deployment' : ''}{(m.blockedUntilTick ?? 0) > sim.tick ? ' - working an event: unavailable for deployment' : ''}</div>
            </span>
            {m.assignedTo === null && m.manager !== true && (m.blockedUntilTick ?? 0) <= sim.tick && deployTarget !== undefined && (
              <button class="btn btn-quiet" style="padding:4px 10px;font-size:11px" onClick={() => { bridge.send('staff.deploy', { staffId: m.id, enclosureId: deployTarget.id }); }}>Deploy</button>
            )}
            {m.assignedTo !== null && (
              <button class="btn btn-quiet" style="padding:4px 10px;font-size:11px" onClick={() => { bridge.send('staff.deploy', { staffId: m.id, enclosureId: null }); }}>Recall</button>
            )}
            <button class="btn btn-quiet" style="padding:4px 10px;font-size:11px" onClick={() => { bridge.send('staff.fire', { staffId: m.id }); }}>Fire</button>
          </div>
        ))}
      </div>
      {sim.overworked && (
        <div style="margin-top:10px;display:flex;justify-content:center">
          <span class="pill pill-red"><IconWarn style="width:16px;height:16px" /><span style="font-size:11px;white-space:nowrap">Overworked: Fatigue rising. Rest required.</span></span>
        </div>
      )}
      <div class="eyebrow" style="margin-top:12px;text-align:center">Hire</div>
      {sim.staffBeds !== null && (
        <div class="row-label" style={`text-align:center;margin-top:4px;${roster.length >= sim.staffBeds ? 'color:var(--ui-amber, #b97a2a);' : ''}`}>
          Beds {roster.length}/{sim.staffBeds}{roster.length >= sim.staffBeds ? ' - full. Build staff housing (Park > Facilities) to hire more.' : ''}
        </div>
      )}
      <div style="display:grid;grid-template-columns:repeat(3,1fr);gap:6px;margin-top:6px">
        {(['ranger', 'veterinarian', 'scout', 'keeper', 'educator', 'guide', 'groundskeeper', 'bookkeeper', 'handler'] as const).map((role) => {
          const wage = sim.staffHireCosts?.find(r => r.role === role)?.wagePerDayCents;
          return (
          <button key={role} class="btn btn-quiet" style="text-transform:capitalize;padding:8px 2px;font-size:10.5px;letter-spacing:0.02em;min-height:0;display:flex;flex-direction:column;gap:0" disabled={sim.staffBeds !== null && roster.length >= sim.staffBeds} onClick={() => { bridge.send('staff.hire', { role }); }}>+ {role === 'veterinarian' ? 'Vet' : role === 'groundskeeper' ? 'Grounds' : role === 'bookkeeper' ? 'Books' : role}<span style="display:block;font-size:10px;text-transform:none;letter-spacing:0;margin-top:4px">{wage === undefined ? 'Wage unavailable' : `$${fmtMoney(wage)}/day`}</span></button>
        ); })}
      </div>
      <div class="row-label" style="font-size:10.5px;margin-top:6px">Current daily wages are shown before hiring. Each hire needs a free staff bed.</div>
      {(() => {
        const free = roster.filter((m) => m.assignedTo === null && m.manager !== true && (m.blockedUntilTick ?? 0) <= sim.tick);
        const target = deployTarget;
        const n = Math.min(Math.max(deployN, 1), Math.max(free.length, 1));
        return (
          <>
            <div style="display:flex;align-items:center;justify-content:space-between;margin-top:12px">
              <span class="eyebrow" style="font-size:12px">Deploy count</span>
              <div class="stepper">
                <button aria-label="Fewer" onClick={() => { setDeployN(Math.max(1, n - 1)); }}>-</button>
                <span class="display" style="min-width:48px;text-align:center;font-size:22px">{n}</span>
                <button aria-label="More" onClick={() => { setDeployN(Math.min(free.length, n + 1)); }}>+</button>
              </div>
            </div>
            <button
              class="btn btn-primary" style="width:100%;margin-top:10px"
              disabled={free.length === 0 || !target}
              onClick={() => { if (target) { free.slice(0, n).forEach((m) => { bridge.send('staff.deploy', { staffId: m.id, enclosureId: target.id }); }); } }}
            >Deploy team</button>
            {free.length === 0 && <div class="row-label" style="text-align:center;margin-top:4px">No available staff to deploy</div>}
            {free.length > 0 && !target && <div class="row-label" style="text-align:center;margin-top:4px">Select a current enclosure to deploy into</div>}
          </>
        );
      })()}
      <button class="btn btn-quiet" style="width:100%;margin-top:8px" onClick={closePanel}>Cancel</button>
      <div style="margin-top:10px">
        <div class="eyebrow" style="text-align:center;margin-bottom:6px">Deployment - {roster.filter((m) => m.assignedTo !== null).length}/{roster.length} staff assigned</div>
        <div class="progress"><div style={`width:${roster.length === 0 ? 0 : Math.round((roster.filter((m) => m.assignedTo !== null).length / roster.length) * 100)}%`} /></div>
      </div>
    </div>
  );
}


/** Lodge management (P406/P408/P409, report-based): rates, specials, cull marks, meat/jerky, guest outing reports. */
function LodgePanel() {
  const { sim, bridge } = useStore();
  const h = sim.hunts;
  const [cureKg, setCureKg] = useState(10);
  const [bk, setBk] = useState({ guest: '', kind: 'management' as 'management' | 'trophy', party: 2, ahead: 3, nights: 2 });
  if (h === null) { return <div style="padding:6px 18px 16px"><div class="eyebrow eyebrow-rule">Lodge</div><p style="font-size:13px;color:var(--ui-ink-soft)">The lodge opens once the scenario starts.</p></div>; }
  const pct = (bp: number) => `${(bp / 100).toFixed(0)}%`;
  const step = (d: number) => { bridge.send('hunting.setRates', { rateBp: Math.max(5000, Math.min(20000, h.rateBp + d)) }); };
  const dayNow = Math.floor(sim.tick / 24);
  const cullable = sim.animals.filter((a) => !h.cullMarks.includes(a.id));
  return (
    <div style="padding:6px 18px 16px">
      <div class="eyebrow eyebrow-rule">Lodge - hunting</div>
      <RanchOperationsPanel/>
      <div class="eyebrow" style="margin-top:18px">Legacy wild outings</div>
      <p style="font-size:13px">These legacy trophy outings are wild, report-based trips. They do not reserve or harvest your ranch animals. Hunt quotes are recorded only, not collected as booking income. Existing report ratings are simulated outing results, not measured horn or antler scores. Ranch-stock calendar offerings are separate above, with player-set success quotes, daily client budgets and departure invoices.</p>
      <div style="display:grid;grid-template-columns:repeat(3,1fr);gap:8px;margin-top:10px;text-align:center">
        <div><div class="row-value">{h.lodgeRating}</div><div class="row-label">Guest rating</div></div>
        <div><div class="row-value">{h.meatKg} kg</div><div class="row-label">Meat</div></div>
        <div><div class="row-value">{h.jerkyKg} kg</div><div class="row-label">Jerky{h.curingKg > 0 ? ` (+${h.curingKg} curing)` : ''}</div></div>
      </div>
      <div class="eyebrow" style="margin-top:12px">Bookings</div>
      <div class="card" style="border:var(--ui-border);background:var(--ui-parchment-soft);margin-top:8px;padding:10px 12px">
        <div class="row-value">Book a hunt</div>
        <input aria-label="Guest name" placeholder="Guest or party name" value={bk.guest} onInput={(e) => { const v = e.currentTarget.value; setBk((b) => ({ ...b, guest: v })); }} style="width:100%;margin-top:8px;padding:8px;border:var(--ui-border);border-radius:var(--ui-radius);background:var(--ui-parchment-soft);box-sizing:border-box" />
        <div class="seg" style="margin-top:8px">
          <button class={bk.kind === 'management' ? 'on' : ''} onClick={() => { setBk((b) => ({ ...b, kind: 'management' })); }}>Management</button>
          <button class={bk.kind === 'trophy' ? 'on' : ''} onClick={() => { setBk((b) => ({ ...b, kind: 'trophy' })); }}>Trophy</button>
        </div>
        {([['Party size', 'party', 1, 'guests'], ['Arrives in', 'ahead', 0, 'days'], ['Nights', 'nights', 1, 'nights']] as const).map(([lbl, key, min, unit]) => (
          <div key={key} style="display:flex;align-items:center;justify-content:space-between;margin-top:8px">
            <span class="eyebrow">{lbl}</span>
            <span class="stepper">
              <button aria-label={`Less ${lbl}`} onClick={() => { setBk((b) => ({ ...b, [key]: Math.max(min, b[key] - 1) })); }}>-</button>
              <span class="stepper-val">{bk[key]} {unit}</span>
              <button aria-label={`More ${lbl}`} onClick={() => { setBk((b) => ({ ...b, [key]: b[key] + 1 })); }}>+</button>
            </span>
          </div>
        ))}
        <button class="btn btn-primary" style="width:100%;margin-top:10px" disabled={bk.guest.trim() === ''} onClick={() => { bridge.send('hunt.book', { guestName: bk.guest.trim(), kind: bk.kind, partySize: bk.party, arriveDay: dayNow + bk.ahead, nights: bk.nights }); }}>Book for day {dayNow + bk.ahead}</button>
        <div class="row-label" style="white-space:normal;margin-top:6px;text-transform:none;letter-spacing:0.01em">Bookings require an open season and space for every night. Maximum party and stay limits apply. Quoted hunt prices are not collected as income.</div>
      </div>
      {h.bookings.length === 0 && <div class="row-label" style="margin-top:4px">No upcoming or active bookings</div>}
      {h.bookings.map((b) => (
        <div key={b.bookingId} class="card row" style="border:var(--ui-border);background:var(--ui-parchment-soft);margin-top:6px;padding:8px 12px;gap:6px;min-height:unset;height:auto;align-items:flex-start">
          <div class="row-main" style="min-width:0;overflow:visible;white-space:normal">
            <div class="row-value" style="font-size:16px">{b.guestName} - {b.kind === 'trophy' ? 'Trophy' : 'Management'}</div>
            <div class="row-label">Day {b.arriveDay}, {b.nights} {b.nights === 1 ? 'night' : 'nights'} - ${fmtMoney(b.priceCents)} quote only - {b.status}</div>
            {b.kind === 'trophy' && b.status === 'active' && (h.outing?.bookingId === b.bookingId ? <div class="row-label">Wild outing in progress - {Math.max(0,h.outing.returnTick-sim.tick)} hours to report</div> : b.outingStartedTick !== undefined && b.outingStartedTick >= 0 ? <div class="row-label">This stay's outing is complete. See the report below.</div> : <div style="margin-top:8px;pointer-events:auto"><button class="btn btn-quiet" disabled={!!h.outing} onClick={() => { bridge.send('hunt.outing.start',{bookingId:b.bookingId,mode:'delegated'}); }}>Start wild report outing</button><select aria-label={`Guide for ${b.guestName}`} value="" disabled={!!h.outing} onChange={e=>{if(e.currentTarget.value)bridge.send('hunt.outing.delegate',{bookingId:b.bookingId,guideStaffId:e.currentTarget.value});}} style="width:100%;margin-top:6px;padding:8px"><option value="">Or assign a deployed guide...</option>{sim.staff.filter(st=>st.role==='guide'&&st.assignedTo!==null&&!st.manager&&(st.blockedUntilTick??0)<=sim.tick).map(st=><option value={st.id}>{st.id} - skill {st.skill}</option>)}</select>{!sim.staff.some(st=>st.role==='guide'&&st.assignedTo!==null&&!st.manager&&(st.blockedUntilTick??0)<=sim.tick)&&<div class="row-label">No deployed guide. Hire and deploy a guide in Staff, or start without one.</div>}</div>)}
          </div>
          {(b.status === 'booked' || b.status === 'upcoming') && dayNow >= b.arriveDay && <button class="btn btn-quiet" style="padding:4px 10px;font-size:11px" onClick={() => { bridge.send('hunt.checkin', { bookingId: b.bookingId }); }}>Check in</button>}
          {b.status !== 'done' && b.status !== 'cancelled' && <button class="btn btn-quiet" style="padding:4px 10px;font-size:11px" onClick={() => { bridge.send('hunt.cancel', { bookingId: b.bookingId }); }}>{b.status === 'active' ? 'End early' : 'Cancel'}</button>}
        </div>
      ))}
      <div class="eyebrow" style="margin-top:12px">Rates</div>
      <div style="display:flex;align-items:center;justify-content:space-between;margin-top:6px">
        <span class="row-value" style="font-size:16px">{pct(h.rateBp)} of base</span>
        <div class="stepper">
          <button aria-label="Lower rates" onClick={() => { step(-500); }}>-</button>
          <button aria-label="Raise rates" onClick={() => { step(500); }}>+</button>
        </div>
      </div>
      <div class="eyebrow" style="margin-top:12px">Special</div>
      {h.special
        ? <div class="row-label" style="margin-top:4px">{pct(h.special.discountBp)} off until day {h.special.untilDay} ({Math.max(0, h.special.untilDay - dayNow)} days left)</div>
        : <button class="btn btn-quiet" style="margin-top:6px;width:100%" onClick={() => { bridge.send('hunting.special', { discountBp: 2000, days: 7 }); }}>Run a 7-day special (20% off)</button>}
      <div class="eyebrow" style="margin-top:12px">Meat and jerky</div>
      <div style="display:flex;align-items:center;justify-content:space-between;margin-top:6px">
        <div class="stepper">
          <button aria-label="Less" onClick={() => { setCureKg(Math.max(5, cureKg - 5)); }}>-</button>
          <span class="display" style="min-width:56px;text-align:center">{cureKg} kg</span>
          <button aria-label="More" onClick={() => { setCureKg(Math.min(Math.max(5, h.meatKg), cureKg + 5)); }}>+</button>
        </div>
        <button class="btn btn-quiet" disabled={h.meatKg < cureKg} onClick={() => { bridge.send('hunting.cure', { kg: cureKg }); }}>Cure into jerky</button>
      </div>
      <div class="eyebrow" style="margin-top:12px">Management cull marks</div>
      {h.cullMarks.length === 0 && <div class="row-label" style="margin-top:4px">No animals marked</div>}
      {h.cullMarks.map((id) => <div key={id} class="row-label" style="margin-top:4px">{sim.animals.find((a) => a.id === id)?.name ?? id} marked for a management hunt</div>)}
      {cullable.length > 0 && (
        <select aria-label="Mark animal for management hunt" value="" onChange={(e) => { if (e.currentTarget.value) { bridge.send('hunting.markCull', { animalId: e.currentTarget.value }); } }} style="width:100%;margin-top:6px;padding:8px;border:var(--ui-border);border-radius:var(--ui-radius);background:var(--ui-parchment-soft)">
          <option value="">Mark an animal...</option>
          {cullable.map((a) => <option key={a.id} value={a.id}>{a.name} - {a.species}</option>)}
        </select>
      )}
      <div class="eyebrow" style="margin-top:12px">Actual sighting reports</div>
      <p class="row-label" style="white-space:normal">Each report belongs to its named party. Sighting satisfaction is simulated, not a measured trophy score. Tip and refund amounts are recorded only, not paid.</p>
      {(h.missingOutingReports ?? []).map(r => <div key={r.bookingId} class="row-label" style="white-space:normal;margin-top:6px">{r.guestName} ({r.bookingId}): this older stay has no retained sighting report. Another party's report is not a substitute.</div>)}
      {(h.actualOutingReports ?? []).slice().reverse().map(r => <div key={`${r.bookingId}-${r.returnedTick}`} class="card" style="padding:10px 12px;margin-top:6px">
        <div class="row-value" style="font-size:16px;white-space:normal">{r.guestName} - {r.bookingId}</div>
        <div class="row-label" style="white-space:normal">Returned day {Math.floor(r.returnedTick / 24)}, hour {r.returnedTick % 24}{r.endedEarly ? ' - ended early' : ''}. Guide: {r.guidedByStaffId ?? 'none'}.</div>
        <div class="row-label" style="white-space:normal">{r.sightings.map(x => `${x.count} ${x.species.replace(/_/g, ' ')}${x.photoQuality === undefined ? '' : ` (photo quality ${x.photoQuality}/100)`}`).join('; ') || 'No sightings recorded'}</div>
        <div class="row-label" style="white-space:normal">Sighting satisfaction {pct(r.qualityBp)}. Tip quote ${fmtMoney(r.tipsCents)}; refund note ${fmtMoney(r.refundDueCents)}. Neither is paid.</div>
        {r.guestRating !== undefined && <div class="row-label">Photo guest rating {r.guestRating}/100{r.appealEstimated ? ' - design-estimate appeal' : ''}</div>}
      </div>)}
      <div class="eyebrow" style="margin-top:12px">Outing reports</div>
      {h.reports.length === 0 && <div class="row-label" style="margin-top:4px">No outings yet</div>}
      {h.reports.slice().reverse().map((r) => (
        <div key={r.bookingId} class="card" style="padding:10px 12px;margin-top:6px">
          <div class="row-value" style="font-size:16px">{r.guestName} - {r.kind === 'photo_tour' ? 'Photo' : r.kind === 'trophy' ? 'Trophy' : 'Management'} outing, day {r.day}</div>
          <div class="row-label" style="white-space:normal">{r.harvested ? `Harvest: ${r.harvested.species.replace(/_/g, ' ')} (${r.harvested.source === 'herd' ? 'herd' : 'wild'}), simulated trophy rating ${pct(r.harvested.trophyQualityBp)}` : 'No harvest this outing'}</div>
          <div class="row-label" style="white-space:normal">Guest satisfaction {r.satisfaction}/100. {r.feeCents === 0 ? 'No fee collected by this report. Booking settlement is separate; tip quotes above are unpaid.' : `Retained report fee $${fmtMoney(r.feeCents)}. This is separate from the unpaid tip quote.`}</div>
        </div>
      ))}
    </div>
  );
}

/** Security (P413): patrol coverage and the last poaching incident. Read-only; patrols are staff.deploy. */
function SecurityPanel() {
  const { sim } = useStore();
  const p = sim.poaching;
  if (p === null) { return <div style="padding:6px 18px 16px"><div class="eyebrow eyebrow-rule">Security</div><p style="font-size:13px;color:var(--ui-ink-soft)">Security opens once the scenario starts.</p></div>; }
  const li = p.lastIncident;
  const name = li?.animalId ? (sim.animals.find((a) => a.id === li.animalId)?.name ?? li.animalId) : null;
  return (
    <div style="padding:6px 18px 16px">
      <div class="eyebrow eyebrow-rule">Security - patrols</div>
      <div style="display:grid;grid-template-columns:repeat(3,1fr);gap:8px;margin-top:10px;text-align:center">
        <div><div class="row-value">{(p.chanceBp / 100).toFixed(1)}%</div><div class="row-label">Daily risk</div></div>
        <div><div class="row-value">{p.rangersOnPatrol}</div><div class="row-label">Rangers on patrol</div></div>
        <div><div class="row-value">{p.incidentsTotal}</div><div class="row-label">Incidents</div></div>
      </div>
      <div class="eyebrow" style="margin-top:12px">Last incident</div>
      {li === null
        ? <div class="row-label" style="margin-top:4px">No incidents so far</div>
        : <div class="card" style="padding:10px 12px;margin-top:6px">
            <div class="row-value" style="font-size:16px">Day {li.day} - poachers on the reserve</div>
            <div class="row-label" style="white-space:normal">{li.species ? `${name ?? 'An animal'} (${li.species.replace(/_/g, ' ')}) was ${li.injured ? 'hurt' : 'frightened'}` : 'No animal was harmed'}. Reputation took a hit.</div>
          </div>}
      <p class="row-label" style="white-space:normal;margin-top:10px">Deployed rangers lower the daily risk (up to a cap). Assign rangers under Office, Staff.</p>
    </div>
  );
}

const REP_TRACKS: Record<string, string> = { zoo_public: 'Zoo public', hunters: 'Hunters', conservationists: 'Conservation', governments: 'Governments', ranchers: 'Ranchers', breeders: 'Breeders' };
function missingText(m: RegionMissing): string {
  if (m.kind === 'parcels') { return `Own ${m.need} parcels here (have ${m.have})`; }
  if (m.kind === 'reputation') { return `${REP_TRACKS[m.track] ?? m.track} reputation ${m.need} (now ${m.have})`; }
  if (m.kind === 'license') { return `Hold the ${m.licenseId} licence`; }
  return `Cash $${fmtMoney(m.need)} for the opening fee (have $${fmtMoney(m.have)})`;
}

/** Land market: parcel.buy / parcel.sell against hud.parcels (docs/COMMANDS.md). */
function LandPanel() {
  const { sim, bridge } = useStore();
  // Buy/sell run on the next sim step. The ack returns a requestId; a refusal arrives as a
  // command_rejected alert keyed by that id, and success shows as the parcel's owned flag
  // flipping. The refusal surfaces here, where the tap happened (same pattern as easements),
  // as well as in the Reserve alert feed. Nothing is assumed before then.
  const [req, setReq] = useState<{ parcelId: string; action: 'buy' | 'sell'; reqId: string | null; phase: 'wait' | 'ok' | 'fail'; text: string } | null>(null);
  const reqLive = useRef(0);
  const statusRef = useRef<HTMLDivElement>(null);
  // The verdict lands a beat after the tap; bring it on screen (a card at the list bottom
  // would otherwise leave the pill tucked behind the tab bar).
  useEffect(() => { if (req !== null && req.phase !== 'wait') { statusRef.current?.scrollIntoView({ block: 'nearest' }); } }, [req]);
  useEffect(() => {
    if (!req || req.phase !== 'wait') { return; }
    const refused = req.reqId === null ? undefined : sim.alertEvents.find((e) => e.type === 'command_rejected' && e.refId === req.reqId);
    const pc = sim.parcels.find((p) => p.id === req.parcelId);
    if (refused) { setReq({ ...req, phase: 'fail', text: `Refused: ${refused.message.replace(/^parcel\.(buy|sell):\s*/, '')}` }); }
    else if (req.reqId !== null && pc && pc.owned === (req.action === 'buy')) { setReq({ ...req, phase: 'ok', text: req.action === 'buy' ? 'Bought.' : 'Sold.' }); }
  }, [sim.alertEvents, sim.parcels, req]);
  const sendParcel = (parcelId: string, action: 'buy' | 'sell'): void => {
    if (req?.phase === 'wait') { return; } // one in flight: extra taps can't stack duplicate refusals
    const mine = ++reqLive.current;
    setReq({ parcelId, action, reqId: null, phase: 'wait', text: '' });
    bridge.sendTracked(`parcel.${action}`, { parcelId }).then((id) => {
      if (reqLive.current !== mine) { return; }
      setReq((r) => (r && r.parcelId === parcelId ? (id === null ? { ...r, text: 'Sent. This preview build cannot report the result.' } : { ...r, reqId: id }) : r));
    }, (err: unknown) => {
      if (reqLive.current !== mine) { return; }
      setReq({ parcelId, action, reqId: null, phase: 'fail', text: `Refused: ${err instanceof Error && err.message ? err.message : 'the sim would not take the request.'}` });
    });
  };
  return (
    <div style="padding:6px 18px 16px">
      <div class="eyebrow eyebrow-rule">Land - parcels</div>
      {sim.parcels.length === 0 && <p style="font-size:13px;color:var(--ui-ink-soft)">The parcel market opens once the scenario starts.</p>}
      {(sim.standing?.regions ?? []).filter((r) => r.state !== 'open' && !r.unlocked).map((r) => (
        <div key={r.id} class="card" style="border:var(--ui-border);background:var(--ui-parchment-soft);margin-top:8px;padding:10px 12px">
          <div class="row-value">{r.name} - {r.state === 'available' ? 'opens next day' : 'locked'}</div>
          <div class="row-label" style="white-space:normal;text-transform:none;letter-spacing:0.01em">Parcels here cannot be bought until the region opens.</div>
          {(r.missing ?? []).map((m, i) => (
            <div key={i} class="row-label" style="white-space:normal;text-transform:none;letter-spacing:0.01em;margin-top:2px">- {missingText(m)}</div>
          ))}
        </div>
      ))}
      {sim.parcels.map((pc) => (
        <div key={pc.id} class="card row" style="border:var(--ui-border);background:var(--ui-parchment-soft);margin-top:8px;flex-wrap:wrap">
          <span class="row-ic"><IconLand /></span>
          <span class="row-main">
            <div class="row-value">Parcel {pc.id} - {pc.landClass}</div>
            <div class="row-label">{pc.hectares} ha - {pc.distanceKm} km out{pc.owned ? ' - owned' : ` - $${fmtMoney(pc.price)}`}</div>
          </span>
          {pc.owned
            ? <button class="btn btn-quiet" style="padding:4px 10px;font-size:11px" onClick={() => { sendParcel(pc.id, 'sell'); }}>Sell</button>
            : <button class="btn btn-quiet" style="padding:4px 10px;font-size:11px" onClick={() => { sendParcel(pc.id, 'buy'); }}>Buy</button>}
          {req && req.parcelId === pc.id && <div ref={statusRef} role="status" class={`pill${req.phase === 'fail' ? ' pill-red' : req.phase === 'wait' ? ' pill-amber' : ''}`} style="display:block;margin-top:8px;text-align:center;white-space:normal;flex-basis:100%">{req.phase === 'wait' ? (req.text !== '' ? req.text : 'Sent. Waiting for the sim to answer.') : req.text}</div>}
        </div>
      ))}
    </div>
  );
}

/** Dealer: licence gate + dealer.buy into a chosen enclosure. */
function DealerPanel() {
  const { sim, bridge } = useStore();
  const [encId, setEncId] = useState<string | null>(null);
  const enc = sim.enclosures.find((e) => e.id === encId) ?? sim.enclosures.at(0);
  const refreshIn = Math.max(0, sim.dealerNextRefreshTick - sim.tick);
  // The sim acknowledges only "queued" and returns a requestId. The purchase runs on the next engine tick, and
  // its outcome (purchased or refused, with the reason) is read from the worker's durable log by that requestId.
  const [buy, setBuy] = useState<{ phase: 'sending' | 'wait' | 'ok' | 'fail'; reqId: string | null; text: string } | null>(null);
  const buyLive = useRef(0);
  const buyPending = buy !== null && (buy.phase === 'sending' || buy.phase === 'wait');
  useEffect(() => {
    if (buy === null || buy.reqId === null || buy.phase !== 'wait') { return; }
    const o = sim.dealerOutcomes.filter((x) => x.requestId === buy.reqId).at(-1);
    if (!o) { return; }
    if (o.outcome === 'purchased') { setBuy({ phase: 'ok', reqId: buy.reqId, text: o.priceCents !== undefined ? `Bought for $${fmtMoney(o.priceCents)}. The animal is in ${o.enclosureId}.` : `Bought. The animal is in ${o.enclosureId}.` }); }
    else { setBuy({ phase: 'fail', reqId: buy.reqId, text: `Refused: ${o.reason ?? 'the sim gave no reason.'}` }); }
  }, [sim.dealerOutcomes, buy]);
  const sendBuy = (offerId: string, enclosureId: string): void => {
    if (buyPending) { return; }
    const mine = ++buyLive.current;
    setBuy({ phase: 'sending', reqId: null, text: '' });
    bridge.sendTracked('dealer.buy', { offerId, enclosureId }).then((id) => {
      if (buyLive.current !== mine) { return; }
      setBuy(id === null ? { phase: 'wait', reqId: null, text: 'Sent. This preview build cannot report the outcome.' } : { phase: 'wait', reqId: id, text: '' });
    }, (err: unknown) => {
      if (buyLive.current !== mine) { return; }
      setBuy({ phase: 'fail', reqId: null, text: `Refused: ${err instanceof Error && err.message ? err.message : 'the sim would not take the request.'}` });
    });
  };
  return (
    <div style="padding:6px 18px 16px">
      <div class="eyebrow eyebrow-rule">Animal dealer</div>
      {buy !== null && buy.phase !== 'sending' && <div role="status" class={`pill${buy.phase === 'fail' ? ' pill-red' : ''}`} style="display:block;margin-top:8px;text-align:center;white-space:normal">{buy.phase === 'wait' ? (buy.text !== '' ? buy.text : 'Sent. Waiting for the sim to answer.') : buy.text}</div>}
      {!sim.licence && (
        <div style="margin-top:10px;text-align:center">
          <p style="font-size:13px;color:var(--ui-ink-soft)">A wildlife licence is required before the dealer will trade.</p>
          <button class="btn btn-primary" style="width:100%;margin-top:6px" onClick={() => { bridge.send('licence.buy', {}); }}>Buy licence</button>
        </div>
      )}
      {sim.licence && (
        <>
          {sim.enclosures.length > 1 && (
            <div style="display:flex;gap:6px;flex-wrap:wrap;margin-top:8px">
              {sim.enclosures.map((e) => (
                <button key={e.id} class={`pill${enc?.id === e.id ? ' pill-amber' : ''}`} style="cursor:pointer" onClick={() => { setEncId(e.id); }}>{e.id} - {e.type.replace(/_/g, ' ')} - {e.animalCount} in it</button>
              ))}
            </div>
          )}
          {sim.dealerOffers.length === 0 && <p style="font-size:13px;color:var(--ui-ink-soft);margin-top:8px">No offers right now{refreshIn > 0 ? ` - new stock in ~${refreshIn}h` : ''}.</p>}
          {sim.dealerOffers.map((o) => (
            <div key={o.id} class="card row" style="border:var(--ui-border);background:var(--ui-parchment-soft);margin-top:8px">
              <span class="row-ic"><IconTag /></span>
              <span class="row-main">
                <div class="row-value">{speciesLabel(o.species)} - {o.sex === 'M' ? 'Male' : 'Female'}</div>
                <div class="row-label">health {o.health} - ${fmtMoney(o.priceCents)}</div>
                <div class="row-label" style="white-space:normal;text-transform:none;letter-spacing:.01em">{o.ageDays===undefined?'Age unavailable':`Age ${o.ageDays} game days`}. {o.maturityDays===undefined?'Breeding maturity unavailable.':`Breeding maturity ${o.maturityDays} days${o.ageDays===undefined?'':o.ageDays>=o.maturityDays?' - old enough; other checks apply.':` - ${o.maturityDays-o.ageDays} days remaining.`}`}</div>
              </span>
              <button
                class="btn btn-quiet" style="padding:4px 10px;font-size:11px"
                disabled={!enc || buyPending}
                onClick={() => { if (enc) { sendBuy(o.id, enc.id); } }}
              >Buy into {enc?.id ?? 'pen'}</button>
            </div>
          ))}
          {sim.enclosures.length === 0 && <p style="font-size:11.5px;color:var(--ui-ink-soft);margin-top:8px">Build an enclosure (Park - build) before buying.</p>}
        </>
      )}
    </div>
  );
}

/** Finance: loan balance + repayment, licence and insurance status. */
function FinancePanel() {
  const { sim, bridge, openPanel } = useStore();
  const [pay, setPay] = useState(10_000_00);
  const [borrow, setBorrow] = useState(50_000_00);
  return (
    <div style="padding:6px 18px 16px">
      <div class="eyebrow eyebrow-rule">Finance</div>
      <div class="card" style="margin-top:10px;padding:12px 16px">
        <div class="row" style="padding:4px 0">
          <span class="row-main"><div class="row-label">Cash</div></span>
          <span class="row-value">${fmtMoney(sim.cashCents)}</span>
        </div>
        <div class="row" style="padding:4px 0">
          <span class="row-main"><div class="row-label">Loan principal</div></span>
          <span class="row-value">{sim.loan ? `$${fmtMoney(sim.loan.principal)}` : 'None'}</span>
        </div>
        {sim.loan && (
          <div class="row" style="padding:4px 0">
            <span class="row-main"><div class="row-label">APR</div></span>
            <span class="row-value">{sim.loan.aprPercent}%</span>
          </div>
        )}
        {sim.business?.taxes && (
          <div class="row" style="padding:4px 0;cursor:pointer" onClick={() => { openPanel({ kind: 'office', section: 'taxes' }); }}>
            <span class="row-main"><div class="row-label">Next tax bill (tap for taxes)</div></span>
            <span class="row-value" style="font-size:14px">${fmtMoney(sim.business.taxes.projected.totalCents)}{sim.business.taxes.unpaidCents > 0 ? ` + $${fmtMoney(sim.business.taxes.unpaidCents)} unpaid` : ''}</span>
          </div>
        )}
        <div class="row" style="padding:4px 0">
          <span class="row-main"><div class="row-label">Licence / insurance</div></span>
          <span class="row-value" style="font-size:13px">{sim.licence ? 'Licenced' : 'No licence'} - {sim.insurance ? 'Insured' : 'Uninsured'}</span>
        </div>
      </div>
      {sim.loan && sim.loan.principal > 0 && (
        <>
          <div style="display:flex;align-items:center;justify-content:space-between;margin-top:12px">
            <span class="eyebrow">Repay</span>
            <span class="stepper">
              <button aria-label="Less" onClick={() => { setPay(Math.max(100_00, pay - 10_000_00)); }}>-</button>
              <span class="stepper-val">${fmtMoney(pay)}</span>
              <button aria-label="More" onClick={() => { setPay(pay + 10_000_00); }}>+</button>
            </span>
          </div>
          <button class="btn btn-primary" style="width:100%;margin-top:8px" onClick={() => { bridge.send('loan.pay', { amountCents: pay }); }}>Pay toward loan</button>
          <div style="display:flex;gap:6px;flex-wrap:wrap;margin-top:8px">
            <button class="btn btn-quiet" style="padding:5px 12px;font-size:12px" disabled={sim.cashCents < sim.loan.principal} onClick={() => { bridge.send('loan.pay', { amountCents: sim.loan?.principal ?? 0 }); }}>Pay off in full (${fmtMoney(sim.loan.principal)})</button>
            <button class="btn btn-quiet" style="padding:5px 12px;font-size:12px" disabled={sim.cashCents < Math.floor(sim.loan.principal / 2)} onClick={() => { bridge.send('loan.pay', { amountCents: Math.floor((sim.loan?.principal ?? 0) / 2) }); }}>Pay half</button>
          </div>
          <div class="row-label" style="white-space:normal;margin-top:4px">Paying down principal lowers what interest is charged on. The sim code adds no early-payoff fee.</div>
        </>
      )}
      <div style="display:flex;align-items:center;justify-content:space-between;margin-top:12px">
        <span class="eyebrow">Borrow</span>
        <span class="stepper">
          <button aria-label="Borrow less" onClick={() => { setBorrow(Math.max(10_000_00, borrow - 10_000_00)); }}>-</button>
          <span class="stepper-val">${fmtMoney(borrow)}</span>
          <button aria-label="Borrow more" onClick={() => { setBorrow(borrow + 10_000_00); }}>+</button>
        </span>
      </div>
      <button class="btn btn-quiet" style="width:100%;margin-top:8px" onClick={() => { bridge.send('loan.take', { amountCents: borrow }); }}>Take the loan</button>
      {sim.loanTerms && sim.loanTerms.maxPrincipalCents - (sim.loan?.principal ?? 0) > 0 && (
        <button class="btn btn-quiet" style="width:100%;margin-top:6px" onClick={() => { bridge.send('loan.take', { amountCents: (sim.loanTerms?.maxPrincipalCents ?? 0) - (sim.loan?.principal ?? 0) }); }}>Borrow up to the cap (${fmtMoney((sim.loanTerms.maxPrincipalCents) - (sim.loan?.principal ?? 0))})</button>
      )}
      <button class="btn btn-quiet" style="width:100%;margin-top:6px" onClick={() => { openPanel({ kind: 'office', section: 'credit' }); }}>Credit rating and debt service</button>
      <div class="row-label" style="white-space:normal;margin-top:4px">{sim.loanTerms ? `New borrowing costs ${sim.loanTerms.takeAprPercent}% a year. The credit line caps total principal at $${fmtMoney(sim.loanTerms.maxPrincipalCents)}.` : 'Borrowing adds to your principal at the credit line rate. The bank caps total principal and will turn down anything over it.'}</div>
      {(() => {
        const m = sim.ledgerMonthly.at(-1);
        if (!m) {
          // No ledger projection yet (older worker): honest estimate from live data.
          return (
            <>
              <div class="eyebrow" style="margin-top:14px;text-align:center">This month - estimated</div>
              <div class="card" style="margin-top:6px;padding:12px 16px">
                <div class="row" style="padding:4px 0">
                  <span class="row-main"><div class="row-label">Wages ({sim.staff.length} staff)</div></span>
                  <span class="row-value" style="font-size:14px">-${fmtMoney(sim.staff.reduce((a, mm) => a + mm.wagePerDay, 0) * 30)}</span>
                </div>
                <div class="row-label" style="margin-top:6px;font-size:10px">Full P&amp;L posts once the ledger projection reaches this build.</div>
              </div>
            </>
          );
        }
        const cats = Object.entries(m.byCategory).sort((a, b) => Math.abs(b[1].netCents) - Math.abs(a[1].netCents)).slice(0, 5);
        return (
          <>
            <div class="eyebrow" style="margin-top:14px;text-align:center">Month {m.month + 1} - ledger</div>
            <div class="card" style="margin-top:6px;padding:12px 16px">
              <div class="row" style="padding:4px 0">
                <span class="row-main"><div class="row-label">Income</div></span>
                <span class="row-value" style="font-size:14px">+${fmtMoney(m.incomeCents)}</span>
              </div>
              <div class="row" style="padding:4px 0">
                <span class="row-main"><div class="row-label">Expense</div></span>
                <span class="row-value" style="font-size:14px">-${fmtMoney(m.expenseCents)}</span>
              </div>
              <div class="row" style="padding:4px 0;border-top:1px solid var(--ui-ink-faint)">
                <span class="row-main"><div class="row-label">Net</div></span>
                <span class="row-value" style="font-size:15px;color:${''}">{m.netCents >= 0 ? '+' : '-'}${fmtMoney(Math.abs(m.netCents))}</span>
              </div>
              {cats.map(([cat, v]) => (
                <div class="row" key={cat} style="padding:3px 0">
                  <span class="row-main"><div class="row-label" style="text-transform:capitalize">{cat.replace(/_/g, ' ')}</div></span>
                  <span class="row-label">{v.netCents >= 0 ? '+' : '-'}${fmtMoney(Math.abs(v.netCents))}</span>
                </div>
              ))}
            </div>
          </>
        );
      })()}
      {!sim.insurance && (
        <button class="btn btn-quiet" style="width:100%;margin-top:8px" onClick={() => { bridge.send('insurance.buy', {}); }}>Buy insurance</button>
      )}
    </div>
  );
}

/** Reports: reserve performance composed from the live hud/mgmt slices. */
function ReportsPanel() {
  const { sim } = useStore();
  const n = sim.animals.length;
  const avg = (xs: number[]) => (xs.length ? Math.round(xs.reduce((a, b) => a + b, 0) / xs.length) : 0);
  const ownedHa = sim.parcels.filter((p) => p.owned).reduce((a, p) => a + p.hectares, 0);
  const row = (label: string, value: string) => (
    <div class="row" style="padding:6px 0">
      <span class="row-main"><div class="row-label">{label}</div></span>
      <span class="row-value" style="font-size:15px">{value}</span>
    </div>
  );
  return (
    <div style="padding:6px 18px 16px">
      <div class="eyebrow eyebrow-rule">Reports - performance</div>
      {sim.dashboard !== null && (
        <div class="card" style="margin-top:10px;padding:6px 16px 10px">
          <div class="eyebrow" style="margin-top:8px">Reserve status</div>
          {sim.dashboard.conflicts.length === 0
            ? <div class="row-label" style="margin-top:6px">No active concerns.</div>
            : (
              <div style="display:flex;flex-wrap:wrap;gap:6px;margin-top:6px">
                {sim.dashboard.conflicts.map((c) => <span key={c.id} class={`pill${c.severity === 'critical' ? ' pill-red' : c.severity === 'warning' ? ' pill-amber' : ''}`} style="white-space:normal;height:auto;text-transform:none;letter-spacing:0.01em">{c.message}</span>)}
              </div>
            )}
          <div class="row-label" style="margin-top:6px">Ill {sim.dashboard.animals.ill}, stressed {sim.dashboard.animals.stressed}, weak {sim.dashboard.animals.weak} of {sim.dashboard.animals.total} {sim.dashboard.animals.total === 1 ? 'animal' : 'animals'} - {sim.dashboard.staff.deployed} of {sim.dashboard.staff.total} staff deployed - {sim.dashboard.activeBookings} active hunt {sim.dashboard.activeBookings === 1 ? 'booking' : 'bookings'}</div>
        </div>
      )}
      <div class="card" style="margin-top:10px;padding:6px 16px 10px">
        <div class="eyebrow" style="margin-top:8px">Herd</div>
        {row('Animals', String(n))}
        {row('Average health', n ? `${avg(sim.animals.map((a) => a.health))}%` : '-') }
        {row('Average stress', n ? `${avg(sim.animals.map((a) => a.stress))}%` : '-') }
      </div>
      <div class="card" style="margin-top:10px;padding:6px 16px 10px">
        <div class="eyebrow" style="margin-top:8px">Staff</div>
        {row('Roster', `${sim.staff.length} (${sim.staff.filter((m) => m.assignedTo !== null).length} deployed)`)}
        {row('Average fatigue', sim.staff.length ? `${avg(sim.staff.map((m) => m.fatigue))}%` : '-')}
        {row('Daily wages', `$${fmtMoney(sim.staff.reduce((a, m) => a + m.wagePerDay, 0))}`)}
      </div>
      <div class="card" style="margin-top:10px;padding:6px 16px 10px">
        <div class="eyebrow" style="margin-top:8px">Land</div>
        {row('Parcels owned', `${sim.parcels.filter((p) => p.owned).length} of ${sim.parcels.length}`)}
        {row('Hectares owned', String(Math.round(ownedHa)))}
        {row('Enclosures', `${sim.enclosures.length} (${sim.enclosures.reduce((a, e) => a + e.animalCount, 0)} ${sim.enclosures.reduce((a, e) => a + e.animalCount, 0) === 1 ? 'animal' : 'animals'} housed)`)}
        {row('Traps set', String(sim.traps.length))}
      </div>
    </div>
  );
}

function StubPanel({ title, text }: { title: string; text: string }) {
  return (
    <div style="padding:16px 18px 20px">
      <div class="eyebrow eyebrow-rule">Office</div>
      <div class="display" style="font-size:24px;margin:8px 0">{title}</div>
      <p style="font-size:14px;color:var(--ui-ink-soft)">{text}</p>
    </div>
  );
}

export function OfficeScreen() {
  const { panel, openPanel, closePanel } = useStore();
  const [officeQ, setOfficeQ] = useState('');
  const section = panel?.kind === 'office' ? panel.section : null;
  const current = SECTIONS.find((s) => s.id === section);
  return (
    <>
      <div class={section ? 'screen-scroll screen-scroll-covered' : 'screen-scroll'} aria-hidden={section ? 'true' : undefined}>
        <div class="eyebrow eyebrow-rule">Office - management</div>
        <input type="search" aria-label="Find an office section" placeholder={`Find a section (${String(SECTIONS.length)})`} value={officeQ} onInput={(e) => { setOfficeQ(e.currentTarget.value); }} style="margin:6px 0 2px;padding:8px 10px;border:var(--ui-border);border-radius:var(--ui-radius);background:var(--ui-parchment-soft);width:100%;box-sizing:border-box" />
        {groupOfficeSections(SECTIONS, officeQ).map((g) => (
          <div key={g.label}>
            <div class="eyebrow eyebrow-rule office-group-h">{g.label}</div>
            {g.sections.map(({ id, label, hint, Icon }) => (
          <button key={id} class="card row" style="border:var(--ui-border);width:100%;text-align:left;cursor:pointer;background:var(--ui-parchment-soft)" onClick={() => { openPanel({ kind: 'office', section: id }); }}>
            <span class="row-ic"><Icon /></span>
            <span class="row-main">
              <div class="row-value">{label}</div>
              <div class="row-label">{hint}</div>
            </span>
            <span class="row-chev"><IconChevron /></span>
          </button>
            ))}
          </div>
        ))}
      </div>
      {section==='workforce'&&<Sheet label="Ranch work board" onClose={closePanel}><WorkforcePanel/></Sheet>}
      {section === 'staff' && (
        <Sheet label="Staff and rangers" onClose={closePanel}><StaffPanel /></Sheet>
      )}
      {section === 'breedlab' && <Sheet label="Breeding lab" onClose={closePanel}><BreedingLabPanel /></Sheet>}
      {section === 'vegetation' && <Sheet label="Pasture and forage" onClose={closePanel}><VegetationPanel /></Sheet>}
      {section === 'restoration' && <Sheet label="Restoration and carbon" onClose={closePanel}><RestorationPanel /></Sheet>}
      {section === 'guest-map' && <Sheet label="Guest ranch build" onClose={closePanel}><GuestMapPanel /></Sheet>}
      {section === 'zoo' && <Sheet label="Zoo gate" onClose={closePanel}><ZooPanel /></Sheet>}
      {section === 'insurance' && <Sheet label="Insurance" onClose={closePanel}><InsurancePanel /></Sheet>}
      {section === 'buyers' && <Sheet label="Ranch buyers" onClose={closePanel}><BuyersPanel /></Sheet>}
      {section === 'taxes' && <Sheet label="Taxes" onClose={closePanel}><TaxesPanel /></Sheet>}
      {section === 'arrivals' && <Sheet label="Auctions and arrivals" onClose={closePanel}><ArrivalsPanel /></Sheet>}
      {section === 'season' && <Sheet label="Season" onClose={closePanel}><SeasonPanel /></Sheet>}
      {section === 'careers' && <Sheet label="Staff careers" onClose={closePanel}><StaffCareerPanel /></Sheet>}
      {section === 'facilities' && <Sheet label="Facilities and upkeep" onClose={closePanel}><FacilitiesPanel /></Sheet>}
      {section === 'credit' && <Sheet label="Credit and debt" onClose={closePanel}><CreditPanel /></Sheet>}
      {section === 'meat' && <Sheet label="Meat and jerky" onClose={closePanel}><MeatPanel /></Sheet>}
      {section === 'specials' && <Sheet label="Specials" onClose={closePanel}><SpecialsPanel /></Sheet>}
      {section === 'partners' && <Sheet label="Partners" onClose={closePanel}><PartnersPanel /></Sheet>}
      {section === 'genetics' && <Sheet label="Genetics exchange" onClose={closePanel}><GeneticsPanel /></Sheet>}
      {section === 'rewilding' && <Sheet label="Rewilding" onClose={closePanel}><RewildingPanel /></Sheet>}
      {section === 'identity' && <Sheet label="Who you are" onClose={closePanel}><IdentityPanel /></Sheet>}
      {section === 'journal' && <Sheet label="Field journal" onClose={closePanel}><JournalPanel /></Sheet>}
      {section === 'story' && <Sheet label="Story" onClose={closePanel}><StoryPanel /></Sheet>}
      {section === 'tourism' && <Sheet label="Tourism" onClose={closePanel}><TourismPanel /></Sheet>}
      {section === 'guest-business' && <Sheet label="Guest business" onClose={closePanel}><GuestResearchPanel /></Sheet>}
      {section === 'standing' && <Sheet label="Standing" onClose={closePanel}><StandingPanel /></Sheet>}
      {section === 'security' && <Sheet label="Security" onClose={closePanel}><SecurityPanel /></Sheet>}
      {section === 'lodge' && <Sheet label="Lodge" onClose={closePanel}><LodgePanel /></Sheet>}
      {section === 'land' && <Sheet label="Land" onClose={closePanel}><LandPanel /></Sheet>}
      {section === 'dealer' && <Sheet label="Dealer" onClose={closePanel}><DealerPanel /></Sheet>}
      {section === 'finance' && <Sheet label="Finance" onClose={closePanel}><FinancePanel /></Sheet>}
      {section === 'overview' && <Sheet label="Business overview" onClose={closePanel}><BusinessOverviewPanel /></Sheet>}
      {section === 'reports' && <Sheet label="Reports" onClose={closePanel}><ReportsPanel /></Sheet>}
      {section === 'research' && <Sheet label="Research" onClose={closePanel}><ResearchPanel /></Sheet>}
      {section === 'contracts' && <Sheet label="Contracts" onClose={closePanel}><ContractsPanel /></Sheet>}
      {section === 'advisors' && <Sheet label="Advisors" onClose={closePanel}><AdvisorsPanel /></Sheet>}
      {section === 'price-history' && <Sheet label="Market prices" onClose={closePanel}><PriceHistoryPanel /></Sheet>}
      {section === 'forecast' && <Sheet label="Forecast" onClose={closePanel}><ForecastPanel /></Sheet>}
      {section === 'breeding' && <Sheet label="Breeding" onClose={closePanel}><PedigreePanel /></Sheet>}
      {section === 'studbook' && <Sheet label="Studbook" onClose={closePanel}><StudbookPanel /></Sheet>}
      {section && !['workforce','journal','guest-map','identity', 'story', 'breedlab', 'vegetation', 'restoration', 'zoo', 'insurance', 'buyers', 'taxes', 'arrivals', 'season', 'careers', 'facilities', 'credit', 'meat', 'specials', 'partners', 'genetics', 'rewilding', 'staff', 'tourism', 'standing', 'security', 'lodge', 'land', 'dealer', 'finance', 'reports', 'research', 'contracts', 'advisors', 'breeding', 'studbook', 'price-history', 'forecast', 'guest-business', 'overview'].includes(section) && current && (
        <Sheet label={current.label} onClose={closePanel}>
          <StubPanel title={current.label} text="No commands exist for this area in the contract yet - requested from Sim-Core. The shell, navigation and panel stack are ready." />
        </Sheet>
      )}
    </>
  );
}
